// extracted by mini-css-extract-plugin
module.exports = {"content":"e_8r","opened":"e_9r","buttonIcon":"e_-r","buttonIconOpen":"e_as","toggle":"e_bs","collapsible":"e_cs"};